export enum Stages {
  CreditDecision = 'CreditDecision',
  Affordability = 'Affordability',
  Packaging = 'Packaging',
  AtLender = 'Underwriting',
  Offer = 'Offer',
  Completion = 'Completion',
}

export const stageOrder = [
  Stages.CreditDecision,
  Stages.Affordability,
  Stages.Packaging,
  Stages.AtLender,
  Stages.Offer,
  Stages.Completion,
];
